module.exports = __webpack_public_path__ + "static/media/background_member_section_colors.26408a6f.jpg";